"use strict";
/* Projects */
Object.defineProperty(exports, "__esModule", { value: true });
var ProjectGeoMarkStatus;
(function (ProjectGeoMarkStatus) {
    ProjectGeoMarkStatus["New"] = "New";
    ProjectGeoMarkStatus["Sold"] = "Sold";
    ProjectGeoMarkStatus["Reserved"] = "Reserved";
    ProjectGeoMarkStatus["Booked"] = "Booked";
    ProjectGeoMarkStatus["Paid"] = "Paid";
    ProjectGeoMarkStatus["CommercialOfferSent"] = "CommercialOfferSent";
    ProjectGeoMarkStatus["Deleted"] = "Deleted";
    ProjectGeoMarkStatus["InEditMode"] = "InEditMode";
    ProjectGeoMarkStatus["_FreeOnlyForFrontend"] = "_FreeOnlyForFrontend";
})(ProjectGeoMarkStatus = exports.ProjectGeoMarkStatus || (exports.ProjectGeoMarkStatus = {}));
var ProjectType;
(function (ProjectType) {
    ProjectType["CommonProject"] = "CommonProject";
    ProjectType["ParentCommercialOfferProject"] = "ParentCommercialOfferProject";
})(ProjectType = exports.ProjectType || (exports.ProjectType = {}));
//# sourceMappingURL=types.js.map